import { Accordion, Image, StatsAtBatPromotion, Typography, createCssVariableString } from "best-common-react";
import React from "react";

const Promotion = ({ name, imageUrl, description, presentedBy, distribution }: StatsAtBatPromotion) => {
  const info = presentedBy && `${presentedBy} | ` + !distribution ? "All Fans" : distribution;
  return (
    <div className="d-flex bcr-gap-2 align-items-start">
      <Image src={imageUrl} alt={name} width="80px" style={{ borderRadius: "4px" }} />
      <div style={{ maxWidth: "300px" }}>
        <Typography variant="bodyLarge" elementStyles={{ weight: "bold" }}>
          {name}
        </Typography>
        <Typography>{description}</Typography>
        <Typography variant="bodySmall" elementStyles={{ weight: "bold" }}>
          {info}
        </Typography>
      </div>
    </div>
  );
};

const Promotions = ({ gamePk, promotions }: { gamePk: string | number; promotions?: null | StatsAtBatPromotion[] }) => {
  if (!!promotions) {
    const preview = promotions?.length === 1 ? promotions[0].name : `(${promotions.length})`;
    return (
      <div style={{ boxShadow: createCssVariableString("bcr-shadows") }}>
        <Accordion accordionKey={gamePk.toString()}>
          <Accordion.Header iconLeft={true} styles={{ header: { background: "var(--color-surface-low)" } }}>
            <div className="d-flex" style={{ background: "var(--color-surface-low)" }}>
              <Typography variant="bodySmall" elementStyles={{ weight: "bold" }}>
                {promotions.length === 1 ? "Promotion:" : "Promotions:"}
              </Typography>
              <Typography variant="bodySmall">{preview}</Typography>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div className="d-flex flex-wrap bcr-gap-3">
              {promotions.map((promotion, index) => (
                <Promotion key={`promotion-${index}`} {...promotion} />
              ))}
            </div>
          </Accordion.Body>
        </Accordion>
      </div>
    );
  } else {
    return null;
  }
};

export default Promotions;
